import React from "react";
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

import "./Blog.css";
import Header from "../Shared/Header/Header";
import SubHeader from "../Shared/SubHeader/SubHeader";
import Footer from "../Shared/Footer/Footer";
import ContactUs from "../Home/ContactUs/ContactUs";

import blog1 from "../../images/blog/blog1.jpg";
import blog2 from "../../images/blog/blog2.jpg";
import blog3 from "../../images/blog/blog3.jpg";
import blog4 from "../../images/blog/blog4.jpg";
import blog5 from "../../images/blog/blog5.jpg";
import blog6 from "../../images/blog/blog6.jpg";

const posts = [
  {
    id: 1,
    title: "ADHD u dorosłych – co to jest i jak rozpoznać?",
    slug: "adhd-u-doroslych-od-objawow-do-diagnozy",
    image: blog6,
    excerpt:
      "Czym jest ADHD u dorosłych, jakie daje objawy i kiedy warto zgłosić się po profesjonalną diagnozę?",
  },
  {
    id: 2,
    title: "Objawy ADHD u dorosłych – jak rozpoznać w codziennym życiu?",
    slug: "objawy-adhd-u-doroslych-w-codziennym-zyciu",
    image: blog5,
    excerpt:
      "Poranny pośpiech, gubienie kluczy, rozgrzebane zadania – jak odróżnić ADHD od „zwykłego” braku organizacji?",
  },
  {
    id: 3,
    title:
      "ADHD czy coś innego? Różnicowanie z depresją, lękiem i wypaleniem",
    slug: "adhd-czy-cos-innego-roznicowanie-z-depresja-lekiem-i-wypaleniem",
    image: blog4,
    excerpt:
      "Problemy z koncentracją, zmęczenie, napięcie – kiedy to ADHD, a kiedy depresja, lęk lub wypalenie zawodowe?",
  },
  {
    id: 4,
    title: "ADHD w pracy, relacjach i nauce – jak sobie radzić?",
    slug: "adhd-w-pracy-relacjach-i-nauce-jak-sobie-radzic",
    image: blog3,
    excerpt:
      "Jak ADHD wpływa na karierę, związki i edukację oraz jakie strategie mogą realnie ułatwić codzienne funkcjonowanie?",
  },
  {
    id: 5,
    title: "Spektrum autyzmu u dorosłych – jak wygląda w praktyce?",
    slug: "spektrum-autyzmu-u-doroslych",
    image: blog2,
    excerpt:
      "Czym różni się obraz autyzmu u dorosłych od tego znanego z dzieciństwa? I dlaczego tak wiele osób maskuje objawy?",
  },
  {
    id: 6,
    title: "Lęk, który nie odpuszcza – kiedy zgłosić się po pomoc?",
    slug: "lek-ktory-nie-odpuszcza",
    image: blog1,
    excerpt:
      "Ciągłe napięcie, zamartwianie się, unikanie sytuacji społecznych – jak odróżnić „stres” od zaburzeń lękowych?",
  },
];

const Blog = () => {
  return (
    <>
      <Header />
      <SubHeader
        title="Blog"
        subtitle="Artykuły o zdrowiu psychicznym, neuroatypowości i pracy nad sobą."
      />

      <div className="offers blog-offers" style={{ marginTop: "2rem" }}>
        <div className="container">
          <div className="row">
            {posts.map((post) => (
              <div className="col-lg-4 mt-3" key={post.id}>
                <div className="member d-flex flex-column align-items-start h-100">
                  <div>
                    <div className="offer-img offer-item text-center">
                      <img
                        src={post.image}
                        className="img-fluid"
                        alt={post.title}
                      />
                    </div>
                    <div className="member-info">
                      <h4
                        style={{
                          marginBottom: "1.2rem",
                          textAlign: "center",
                          minHeight: "60px",
                        }}
                      >
                        {post.title}
                      </h4>

                      <p style={{ fontSize: "15px" }}>{post.excerpt}</p>

                      <div className="text-end" style={{ marginTop: "2rem" }}>
                        <Link to={`/blog/${post.slug}`} className="more-btn">
                          <BsFillArrowRightCircleFill /> Czytaj artykuł
                          <i className="bx bx-chevron-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUs />
      <Footer />
    </>
  );
};

export default Blog;
